export default __webpack_public_path__ + "mithril.7e5605b4.png";